export default "__VITE_ASSET__CiIGuGav__"